import React, { useEffect } from 'react';
import { useMapEvents } from 'react-leaflet';
import { Locate } from 'lucide-react';

export function RecenterButton({ onClick, locating }) {
  return (
    <button
      data-testid="recenter-btn"
      onClick={onClick}
      disabled={locating}
      className="absolute z-[1000] bottom-28 right-4 sm:right-6 w-11 h-11 rounded-full glass-panel flex items-center justify-center hover:-translate-y-0.5 transition disabled:opacity-60"
      title="Center on my location"
      aria-label="Center on my location"
    >
      <Locate className={`w-5 h-5 text-brand-ink ${locating ? 'animate-spin' : ''}`} />
    </button>
  );
}

export function MapClickHandler({ onDblClick, onSingleClick, onZoom, onBounds }) {
  const map = useMapEvents({
    dblclick: (e) => onDblClick && onDblClick(e.latlng),
    click: () => onSingleClick && onSingleClick(),
    zoomend: (e) => { onZoom && onZoom(e.target.getZoom()); onBounds && onBounds(e.target.getBounds()); },
    moveend: (e) => onBounds && onBounds(e.target.getBounds()),
  });
  useEffect(() => { onBounds && onBounds(map.getBounds()); }, [map, onBounds]);
  return null;
}
